import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { HowDoIVideoLinks } from "../common/commonvariables";
import { Router } from '@angular/router';
import { BaseComponent } from "../shared/base/base-component";
import { AlertService } from "../alert-panel/alert.service";
import { LoggingPanelModel } from "../_models/common/LoggingPanelModel";
import { ApiRequest, IApiresponse, LogObjectActionTemplateEnum, ApprovalRuleSetting, FunctionPackageEnum } from "../_models";
import { LoggingPanelService } from "../_services/logging-panel/logging-panel.service";
import { ClaimsService } from "../_services/common/claims.service";
import { Claims } from "../_models/common/claims";
import { StateService } from "../_services";
import { ToastrService } from "ngx-toastr";
import { Observable, of, Subscription } from "rxjs";
import { environment } from "../../environments/environment";
import { OrganisationSettingService } from "../_services/organisation-setting/organisation-setting.service";
import { TwostepapprovalService } from "../_services/twostepapproval/twostepapproval.service";
import { ITwoStepApprovalSaveRequest, TwoStepApprovalSaveRequest } from "../_models/twostepapproval/twostepapproval";
import { AlertPanelModel } from "../_models/common/alertPanelModel";
import { GetSetReminderConfigurationReqResp, ReminderConfiguration } from '../_models/reminder-configuration';
import { MarketingPopup } from "../_models/common/marketing-popup";
import { ReminderoptionEnum, ReminderPanelTypeEnum } from '../_models/enum/solo-enum';
import { DashboardService } from '../_services/common/dashboard.service';
import { ApprovalRuleSaveRequest } from "../_models/application-setting/approval-rule";

@Component({
    selector: 'app-cost-centre-on-off',
    templateUrl: './cost-centre-on-off.component.html',
    styleUrls: ['./cost-centre-on-off.component.scss'],
    standalone: false
})
export class CostCentreOnOffComponent extends BaseComponent implements OnInit {
  @Output() closePanel = new EventEmitter<void>();
  @Output() closePanelEvent = new EventEmitter<void>();
  
  howDoIVideoLinks = HowDoIVideoLinks;
  param: string;
  hasFormChanges: boolean;
  claims: Claims;
  isCostCentreOn: boolean;
  isCustomerOn: boolean;
  originalCostCentreState: boolean;
  originalCustomerState: boolean;
  alertSubscription: Subscription;
  alertPanelModel: AlertPanelModel;
  showTurnOffConfirmation: boolean = false;
  
  // Marketing popup properties
  marketingPopupModel: MarketingPopup;
  showMarketingPopup: boolean = false;
  
  // Reminder properties
  reminderConfiguration: any;
  
  // Approval rule properties
  infoToaster: any;
  needsApprovalRuleReset: boolean = false;
  showApprovalRulePanel: boolean = false;

  constructor(
    private translate: TranslateService, 
    private router: Router,
    private alertService: AlertService,
    private loggingPanelService: LoggingPanelService,
    private claimsService: ClaimsService,
    private organisationSettingService: OrganisationSettingService,
    private twoStepApprovalService: TwostepapprovalService,
    private toastr: ToastrService,
    private dashboardService: DashboardService
  ) { 
    super();
    this.claimsService.currentClaims.subscribe((claims) => {
      this.claims = claims;
    });
    this.alertSubscription = this.alertService
      .getUserActionEvent()
      .subscribe((action) => {
        if (action) {
          this.hasFormChanges = false;
          this.backToSettings();
        }
      });
  }

  ngOnInit() {
    this.hasFormChanges = false;
    this.isCostCentreOn = false;
    this.isCustomerOn = false;
    this.alertPanelModel = new AlertPanelModel(false, "", [""], "", "", true, this.translate.instant("please_review_or_confirm"));
    this.GetOrganisationPreferences();
    this.GetSetReminderConfiguration(); // Get reminder data on init
  }

  GetOrganisationPreferences() {
    let request = new ApiRequest<any>(
      "GetOrganisationPreferences",
      environment.applicationVersion,
      environment.requestId
    );
    this.organisationSettingService
      .GetOrganisationPreferences(request)
      .subscribe((data: IApiresponse<any>) => {
        if (data.statusCode == 0) {
          this.isCostCentreOn = data.responseInfo.isCostCentreOn || false;
          this.isCustomerOn = data.responseInfo.isCustomerOn || false;
          // Store original states to check for actual changes
          this.originalCostCentreState = this.isCostCentreOn;
          this.originalCustomerState = this.isCustomerOn;
        }
      });
  }

  GetSetReminderConfiguration() {
    try {
      let requestData = new GetSetReminderConfigurationReqResp();
      requestData.action = 1; // 1 for get/load action
      requestData.orgId = this.claims.OrgId;
      requestData.reminderPanelType = ReminderPanelTypeEnum.CostCentre;
      
      this.dashboardService.GetSetReminderConfiguration(requestData).subscribe({
        next: (response) => {
          if (response && response.responseInfo && response.responseInfo.reminderConfigurations 
            && response.responseInfo.reminderConfigurations.length > 0) {
            this.reminderConfiguration = response.responseInfo.reminderConfigurations[0];
          } else {
            this.reminderConfiguration = null;
          }
        },
        error: (error) => {
          console.error('Error loading reminder configuration:', error);
          this.reminderConfiguration = null;
        }
      });
    } catch (error) {
      console.error('Error in GetSetReminderConfiguration:', error);
      this.reminderConfiguration = null;
    }
  }

  saveNoReminderConfiguration() {
    try {
      // Create reminder configuration object with NoReminder option
      const reminderConfig = new ReminderConfiguration();
      reminderConfig.reminderType = ReminderoptionEnum.NoReminder;
      reminderConfig.reminderPanelType = ReminderPanelTypeEnum.CostCentre;
      reminderConfig.reminderStartDate = 0; // No reminder date
      reminderConfig.reminderSetDate = new Date().getTime();
      reminderConfig.reminderSetByUser = this.claims.UserId;
      reminderConfig.orgId = this.claims.OrgId;
      
      // Create request object
      const requestData = new GetSetReminderConfigurationReqResp();
      requestData.reminderConfigurations = [reminderConfig];
      requestData.action = 2; // 2 for save/set action
      requestData.orgId = this.claims.OrgId;
      requestData.reminderPanelType = ReminderPanelTypeEnum.CostCentre;
      
      // Call the service
      this.dashboardService.GetSetReminderConfiguration(requestData).subscribe({
        next: (response) => {
          if (response && response.statusCode === 200) {
            console.log('NoReminder configuration saved successfully');
          } else {
            console.error('Failed to save NoReminder configuration:', response.message);
          }
        },
        error: (error) => {
          console.error('Error saving NoReminder configuration:', error);
        }
      });
      
    } catch (error) {
      console.error('Error in saveNoReminderConfiguration:', error);
    }
  }

  checkAndHandleReminder() {
    // Check the cached reminder configuration (no server call needed)
    if (!this.reminderConfiguration) {
      // No reminder data exists, save NoReminder configuration
      this.saveNoReminderConfiguration();
    }
    // Always allow the action to proceed regardless of reminder data presence
  }

  fnDisplayMarketingPopUp(FunctionId) {
    switch (FunctionId) {
      case FunctionPackageEnum.Customer:
        this.marketingPopupModel = new MarketingPopup(
          this.translate.instant('label_customers'),
          this.translate.instant("customer_marketing_pop_text"),
          this.translate.instant("customer_marketing_pop_text1"),
          "",
          "../../assets/images/customer_marketing_image.svg",
          "../../assets/images/customer_mrk_sample.png",
          "",
          FunctionPackageEnum.Customer,
          this.translate.instant('label_customers'),
          "cccustomer/customer",
          0, 0
        );
        break;
      default:
        break;
    }
    this.showMarketingPopup = true;
  }

  removeInfoToaster() {
    if (this.infoToaster) {
      this.toastr.remove(this.infoToaster.toastId);
      this.infoToaster = null;
    }
  }

  saveApprovalRules(): Observable<boolean> {
    return new Observable(observer => {
      this.infoToaster = this.toastr.info(this.translate.instant('request_processing_info'), '', {
        disableTimeOut: true,
        tapToDismiss: false
      });

      const approvalRuleSaveRequest = new ApprovalRuleSaveRequest(
        ApprovalRuleSetting.Manual, // Set to manual (1)
        this.getApprovalRuleText(this.claims.ApprovalRuleSetting),
        this.getApprovalRuleText(ApprovalRuleSetting.Manual),
        this.claims.FinanceManager
      );

      this.organisationSettingService.saveApprovalRuleSetting(approvalRuleSaveRequest).subscribe({
        next: () => {
          this.removeInfoToaster();
          this.claims.ApprovalRuleSetting = ApprovalRuleSetting.Manual;
          this.claimsService.updateClaims(this.claims);
          observer.next(true);
          observer.complete();
        },
        error: (error) => {
          this.removeInfoToaster();
          this.toastr.error(this.translate.instant("error_occurred"));
          observer.next(false);
          observer.complete();
        }
      });
    });
  }

  getApprovalRuleText(approvalRuleId) {
    let text = '';
    switch (approvalRuleId) {
      case 1:
        text = this.translate.instant('label_manual_assignment');
        break;
      case 2:
        text = this.translate.instant('label_auto_assignment') + ' - ' + this.translate.instant('auto_approval_rule_a');
        break;
      case 3:
        text = this.translate.instant('label_auto_assignment') + ' - ' + this.translate.instant('auto_approval_rule_b');
        break;
      case 4:
        text = this.translate.instant('label_auto_assignment') + ' - ' + this.translate.instant('auto_approval_rule_c');
        break;
      case 5:
        text = this.translate.instant('label_auto_assignment') + ' - ' + this.translate.instant('auto_approval_rule_d');
        break;
      case 6:
        text = this.translate.instant('label_auto_assignment') + ' - ' + this.translate.instant('auto_approval_rule_e');
        break;
    }
    return text;
  }

  backToSettings() {
    // Check and handle reminder before closing
    this.checkAndHandleReminder();
    
    if (this.canDeactivate()) {
      // Emit close event to parent component
      this.closePanel.emit();
      this.closePanelEvent.emit();
    } else {
      this.alertService.onFormClosed();
    }
  }

  canDeactivate(): boolean {
    return !this.hasFormChanges;
  }

  fnShowConfigureshowLoggingAlertPanel() {
    const model = new LoggingPanelModel(
      this.claims.OrgId.toString(),
      LogObjectActionTemplateEnum.IsCostCentreOnOff.toString(),
      "0"
    );
    this.loggingPanelService.onShowLogPanel(model);
  }

  fnSetCostCentre(isCostCentreOn: boolean, IsChanged: boolean) {
    this.hasFormChanges = IsChanged;
    this.isCostCentreOn = isCostCentreOn;
  }

  fnSetCustomer(isCustomerOn: boolean, IsChanged: boolean) {
    // If customer package is not purchased, don't allow any changes and show marketing popup
    if (!this.claims.IsCustomerPackagePurchasedOrTrial) {
      this.fnDisplayMarketingPopUp(FunctionPackageEnum.Customer);
      return;
    }
    
    this.hasFormChanges = IsChanged;
    this.isCustomerOn = isCustomerOn;
  }

  onCustomerSectionClick() {
    // Show marketing popup when clicking on disabled customer section
    if (!this.claims.IsCustomerPackagePurchasedOrTrial) {
      this.fnDisplayMarketingPopUp(FunctionPackageEnum.Customer);
    }
  }

  isCustomerFeatureAvailable(): boolean {
    return this.claims && this.claims.IsCustomerPackagePurchasedOrTrial;
  }

  openApprovalRulePanel() {
    this.showApprovalRulePanel = true;
  }

  closeApprovalRulePanel(isClose: boolean) {
    if (isClose) {
      this.showApprovalRulePanel = false;
      // Don't reset the state variables as user might return to the alert panel
    }
  }

  showTurnOffAlert() {
    const turningOffCostCentre = this.originalCostCentreState === true && this.isCostCentreOn === false;
    const turningOffCustomer = this.originalCustomerState === true && this.isCustomerOn === false;
    
    let featureNames = [];
    if (turningOffCostCentre) {
      featureNames.push("Cost Centre");
    }
    if (turningOffCustomer) {
      featureNames.push("Customer");
    }
    
    const featureText = featureNames.join(" and ");
    
    // Build alert messages
    let alertMessages = [];
    
    if (turningOffCostCentre) {
      alertMessages.push(this.translate.instant("self_setup_16_msg_25"));

      // Add approval rule message if applicable
      if (this.claims.ApprovalRuleSetting && this.claims.ApprovalRuleSetting > 1) {
        alertMessages.push(this.translate.instant("self_setup_16_msg_26"));
      }
    }
    
    if (turningOffCustomer) {
      alertMessages.push(this.translate.instant("self_setup_16_msg_27"));
    }
    
    // Check if approval rule setting needs to be reset when turning off cost centre
    // This applies when:
    // 1. Turning off cost centre alone
    // 2. Turning off both cost centre and customer (but NOT when turning off customer only)
    this.needsApprovalRuleReset = false;
    if (turningOffCostCentre && 
        this.claims.ApprovalRuleSetting && 
        this.claims.ApprovalRuleSetting > 1) {
      this.needsApprovalRuleReset = true;
    }
    
    this.showTurnOffConfirmation = true;
    this.alertPanelModel = new AlertPanelModel(
      true,
      this.translate.instant("label_confirm"),
      alertMessages,
      this.translate.instant("label_cancel"),
      this.translate.instant("label_confirm"),
      true,
      this.translate.instant("please_review_or_confirm")
    );
    
    // Add approval rule button if needed
    if (this.needsApprovalRuleReset) {
      this.alertPanelModel.btnArray = [
        {
          btnText: this.translate.instant("label_cancel"),
          btnClass: 'btn eod-btn-outline-warning mr-2',
          btnAction: 0 // Cancel action
        },
        {
          btnText: this.translate.instant("self_setup_16_msg_28"),
          btnClass: 'btn eod-btn-warning mr-2',
          btnAction: 2 // Open approval rule panel action
        },
        {
          btnText: this.translate.instant("label_confirm"),
          btnClass: 'btn eod-btn-primary',
          btnAction: 1 // Confirm action
        }
      ];
    }
  }

  alertPanelReceiver(action: any) {
    if ((action === true || action === 1) && this.showTurnOffConfirmation) {
      // User confirmed to turn off Cost Centre
      if (this.needsApprovalRuleReset) {
        // First reset approval rule to manual, then save cost centre settings
        this.saveApprovalRules().subscribe(approvalRuleSuccess => {
          if (approvalRuleSuccess) {
            this.performSave();
          }
        });
      } else {
        // Just save cost centre settings
        this.performSave();
      }
    } else if (action === 2) {
      // User clicked "Configure Approval Rule" button
      // Close the alert panel first
      this.alertPanelModel = new AlertPanelModel(false, "", [""], "", "", true, this.translate.instant("please_review_or_confirm"));
      this.showTurnOffConfirmation = false;
      
      // Then open the approval rule panel
      this.openApprovalRulePanel();
    }
    
    // Reset alert panel (except when opening approval rule panel which handles its own reset)
    if (action !== 2) {
      this.alertPanelModel = new AlertPanelModel(false, "", [""], "", "", true, this.translate.instant("please_review_or_confirm"));
      this.showTurnOffConfirmation = false;
      this.needsApprovalRuleReset = false;
    }
  }

  Save() {
    // Prevent saving if trying to enable customer without purchasing the package
    if (this.isCustomerOn && !this.claims.IsCustomerPackagePurchasedOrTrial) {
      this.fnDisplayMarketingPopUp(FunctionPackageEnum.Customer);
      return;
    }
    
    // Check if we're actually turning off something that's currently on
    const turningOffCostCentre = this.originalCostCentreState === true && this.isCostCentreOn === false;
    const turningOffCustomer = this.originalCustomerState === true && this.isCustomerOn === false;
    
    if (turningOffCostCentre || turningOffCustomer) {
      this.showTurnOffAlert();
    } else {
      this.performSave();
    }
  }

  performSave() {
    // Check and handle reminder before saving
    this.checkAndHandleReminder();
    
    let saveRequest: ITwoStepApprovalSaveRequest = new TwoStepApprovalSaveRequest();
    saveRequest.OrgId = this.claims.OrgId;
    saveRequest.isCostCentreOn = this.isCostCentreOn;
    saveRequest.isCustomerOn = this.isCustomerOn;

    let apiRequest = new ApiRequest<ITwoStepApprovalSaveRequest>(
      "UpdateCostCentreAndCustomerOnOffForOrganisation",
      environment.applicationVersion,
      environment.requestId
    );
    apiRequest.requestInfo = saveRequest;

    this.twoStepApprovalService.UpdateCostCentreAndCustomerOnOffForOrganisation(apiRequest).subscribe((response: IApiresponse<any>) => {
      if (response.statusCode === 0) {
        this.toastr.success(this.translate.instant("success"));
        this.hasFormChanges = false;
        
        // Update claims with the new Cost Centre and Customer settings
        this.claims.isCostCentreOn = this.isCostCentreOn;
        this.claims.isCustomerOn = this.isCustomerOn;
        this.claimsService.updateClaims(this.claims);
      } else {
        this.toastr.error(response.errorInfo[0].message);
      }
    });
  }
}
